<template>
	<BaseModal
		ref="root"
		class="alternative-flights"
		header-title="Alternative Flüge"
	>
		<template #header>
			<CurrentOffer
				:offer-data="offerData"
				:checkout-url
				:price="offerPrice"
			/>
		</template>
		<template #default>
			<template v-if="alternativeFlights">
				<AlternativeFlight
					v-for="flight in alternativeFlights.Offers"
					:key="flight.OfferID"
					:price="offerPrice"
					:alternative-flight="flight"
					:form-data
				/>
			</template>
		</template>
	</BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import CurrentOffer from './internals/CurrentOffer.vue';
import AlternativeFlight from './internals/AlternativeFlight.vue';

import { computed, useTemplateRef } from 'vue';
import type { AlternativeFlightsDataArray, MergedOfferItemData } from '@/interfaces/offer';
import { useStore } from '@/components/common/store';
import { getFinalCurrency, getFinalPrice } from '@/js/utils/priceUtils';
import type { ClientCurrency } from '@global-js/constants';

interface Props {
	offerData: MergedOfferItemData;
	alternativeFlights: AlternativeFlightsDataArray | false;
	checkoutUrl: string;
}
const { offerData } = defineProps<Props>();

const store = useStore();
const formData = computed(() => store.state.searchMask);
const modalRoot = useTemplateRef('root');

const openModal = () => {
	modalRoot.value?.openModal();
};
const offerPrice = computed(() => {
	const amount = getFinalPrice(
		offerData.Status!,
		typeof offerData.Price === 'string' ? Number.parseFloat(offerData.Price) : offerData.Price,
		offerData.unverifiedPrice,
		offerData.TravellerAmount
	);
	const currency = getFinalCurrency(offerData.Status!, offerData.CurrencyCode, offerData.unverifiedCurrency) as ClientCurrency;
	return {
		amount,
		currency,
	};
});

defineExpose({ openModal });
</script>

<style lang="scss">
.alternative-flights {
	.base-modal__header-slot {
		box-shadow: 0.3rem 0.4rem 1.4rem 0 #6663;
		z-index: 1;
	}

	.base-modal__main {
		background-color: $color-white;
	}
}
</style>

<style lang="scss" scoped>
.alternative-flights {
	overflow: hidden;
}
</style>
